import styled from 'styled-components';

export const MLISpecificationStyles = styled.section``;
